import { IOperatorAssignedTaskListVM } from '../../models/response/IOperatorAssignedTaskResponse';
const initialAssignedProcessState: IOperatorAssignedTaskListVM = {
  UserProcess: [],
};

export default initialAssignedProcessState;
